import { useDispatch } from 'react-redux';
import { INTERBRANCH_MODAL_UPDATE } from '../../actions/type';

/**
 * Custom hook to show confirmation dialog when navigating away with unsaved changes
 * @param {boolean} hasUnsavedChanges - Whether there are unsaved changes
 * @param {string} message - Custom message to show in confirmation dialog
 * @returns {function} - Function to handle navigation with confirmation
 */
export const useNavigationConfirmation = (hasUnsavedChanges = false, message = "You have unsaved changes. Are you sure you want to leave this section?") => {
  const dispatch = useDispatch();

  /**
   * Handle navigation with confirmation if there are unsaved changes
   * @param {function} navigationFunction - Function to execute if user confirms
   * @param {string} customMessage - Optional custom message for this specific navigation
   */
  const handleNavigationWithConfirmation = (navigationFunction, customMessage = null) => {
    if (hasUnsavedChanges) {
      // Show confirmation modal
      dispatch({
        type: INTERBRANCH_MODAL_UPDATE,
        payload: {
          modalName: "unsavedChangesConfirmation",
          isVisible: true,
          data: {
            message: customMessage || message,
            onConfirm: () => {
              // User confirmed, execute navigation
              if (navigationFunction) {
                navigationFunction();
              }
            },
            onCancel: () => {
              // User cancelled, do nothing (stay on current page)
              console.log("User cancelled navigation");
            }
          }
        }
      });
    } else {
      // No unsaved changes, proceed with navigation
      if (navigationFunction) {
        navigationFunction();
      }
    }
  };

  return handleNavigationWithConfirmation;
};

export default useNavigationConfirmation;
